import { Link } from "react-router-dom";
import { Nav, NavItem } from "reactstrap";
import { Href } from "../../../../Constants/Constants";
import { ContactNavData } from "../../../../Data/Applications/Contacts/Contacts";
import { LeftContactAsideProps } from "../../../../Types/ContactType";
import AddContact from "./ContactModals/AddContact/AddContact";
import CategoryModal from "./ContactModals/CategoryModal";

const ContactNav: React.FC<LeftContactAsideProps> = ({ activeTab, setActiveTab, changeTab }) => {
  const tabClick = (id: number) => {
    setActiveTab(id);
    changeTab(id);
  };
  return (
    <Nav className="main-menu contact-options custom-scrollbar">
      <NavItem>
        <AddContact />
      </NavItem>
      <NavItem>
        <span className="main-title">{"Views"}</span>
      </NavItem>
      <NavItem>
        <Link to={Href} className={activeTab === 1 ? "active" : ""} onClick={() => tabClick(1)}>
          <span className="title">{"Personal"}</span>
        </Link>
      </NavItem>
      <NavItem>
        <CategoryModal />
      </NavItem>
      {ContactNavData.map((item) => (
        <NavItem key={item.id}>
          <Link to={Href} className={activeTab === item.id ? "active" : ""} onClick={() => tabClick(item.id)}>
            <span className="title">{item.title}</span>
          </Link>
        </NavItem>
      ))}
    </Nav>
  );
};
export default ContactNav;
